// Module
var code = `<select id="languageDropdown" class="form-control" ng-disabled="!languageDropdownController.editable" ng-model="languageDropdownController.value" ng-options="language.key as language.name for language in languageDropdownController.supported" ng-change="languageDropdownController.update()"> <option></option> </select> `;
// Exports
module.exports = code;